<template>
    <PageBaseNoHeader :class="[!isJACareerEntrepreApp ? 'content-background' : 'background-secondary']">
        <router-view></router-view>
    </PageBaseNoHeader>
</template>

<script>
    import PageBaseNoHeader from '../Components/PageBaseNoHeader.vue'

    export default {
        name: 'SecurityPage',
        components: {PageBaseNoHeader}
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"

    .content-background
        background-color color-1
        min-height calc(100vh)

    .background-secondary
        background-color color-blank
        min-height calc(100vh)

</style>
